
<script>
	import footerIndex from './footer/index.vue'
	import listBase from '@_system/components/base/list.vue'
	export default {
		extends: listBase,
		name: 'stafflifecycleIndex',
		props: {

		},
		render(h) {
			this.$slots.footer = [
				<div style="position: relative;width: 100%;height:100%;">
					<footer-index list={this} ref="footer" row={this.currentrow} />
				</div>
			]
			return listBase.render.call(this, h)
		},
		data() {
			return {
				moduleName: 'stafflifecycle',
				windowName: '客服生命周期',
				windowType: 'modal',
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {
			cellClick({row}) {		
				this.currentrow = row
				this.$nextTick(()=>{
					this.$refs.footer.inittab()
				})
			},
		},
		components: {
			footerIndex	
		}
	}
</script>
